import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/spring/topic/index', method: 'GET', params }, { interceptResultCode: false });
};

// 召回初始化
export const recallInitAPI = (params) => {
  return axios({ url: '/snail/spring/topic/invite', method: 'GET', params }, { interceptResultCode: false });
};

// 召回 绑定队友
export const recallBindPlayerAPI = (data) => {
  return axios({ url: '/snail/spring/topic/invite/entry', method: 'POST', data }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetTimeAPI = (params) => {
  return axios({ url: '/snail/year/show', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/snail/midAutumnRecall/api.js